import React, { useState, useRef, useContext } from "react";
import api from '../../services/api';
import { StyledUploadTimeSheet } from "../../styled-components/StyledUploadTimeSheet.style";
import { ModalImportarTimeSheet } from "../ModalImportarTimeSheet";
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import Swal from "sweetalert2";


const UploadTimeSheet = ({ idTimesheet, disabledUpload }) => {
    const inputFile = useRef(null);
    var [file, setFile] = useState([]);
    var [fileName, setFileName] = useState(null);
    const [listaItemAtividades, setlistaItemAtividades] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [valorTotal, setValorTotal] = useState(0);
    const [totalAtividades, setTotalAtividades] = useState(0);
    const [grupoAtividades, setGrupoAtividades] = useState([]);
    const [importData, setImportData] = useState([]);
    const [quantidadeHoras, setquantidadeHoras] = useState(0);
    const [alertData, setAlertaData] = useState(0);
    const [alertPerito, setAlertPerito] = useState(0);
    const { timesheetItemAtividade, setTimesheetItemAtividade,
        idTimesheetItemAtividade, setIdTimesheetItemAtividade,
        timesheetAtividade, setTimesheetAtividade,
        valoresAtividades, setValoresAtividades,
        timesheet, setTimesheet,
        showAtividades, setShowAtividades, dataLancamento, setdataLancamento } = useContext(TimeSheetDetalhesContext);
    const afterOpenModal = () => { };

    const closeModal = () => {
        setIsOpen(false);
    }


    const checkFileName = (fileName, sigla, numero) => {

        const regex = new RegExp(`(${sigla})(.*)(${numero})`);
        return regex.test(fileName) && fileName.includes(sigla) && fileName.includes(numero);
    };

    const handleChange = async (e) => {
        file = [e.target.files[0]];
        setFile(file);

        fileName = e.target.files[0].name;
        setFileName(fileName);
        setTimesheet(timesheet);

        const sigla = timesheet.pericia.sigla;
        const numero = timesheet.timesheet.numeroTimesheet;

        if (!checkFileName(fileName, sigla, numero)) {
            const msg = `O Arquivo ${fileName} não contém a sigla ${sigla} e/ou Número ${numero}!`
            Swal.close();
            Swal.fire({
                title: "Atenção",
                text: msg,
                icon: "error",
                confirmButtonText: "OK",
            });
            e.target.value = '';
            return;

        }

        Swal.fire({
            title: 'Aguarde...',
            html: 'Verificando TimeSheet.',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading()
            },
        });


        let result = null;
        const formData = new FormData();
        formData.append("File", e.target.files[0]);
        formData.append("IdTimesheet", idTimesheet);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        try {
            const response = await api.post(`Timesheet/import`, formData, config);
            result = response.data;
            Swal.close();
            setIsOpen(true);

            setImportData(result);
            setTotalAtividades(result.data.atividadeTimesheet.quantidadeImportadas);
            setValorTotal(result.data.atividadeTimesheet.totalValor);
            setquantidadeHoras(result.data.atividadeTimesheet.quantidadeHoras);
            setlistaItemAtividades(result.data.itens.itemAtividades);
            setGrupoAtividades(result.data.itens.ItemGrupoAtividades);
            setAlertaData(result.data.mensagens.length);
            e.target.value = '';
            return result;
        } catch (err) {
            Swal.close();
            Swal.fire({
                title: "Atenção",
                text: "Não foi possível processar essa planilha, tente novamente em instantes e caso o erro persista contacte um de nossos administradores do sistema!",
                icon: "error",
                confirmButtonText: "OK",
            });

            e.target.value = '';
            return result;
        }
    }

    return (
        <StyledUploadTimeSheet>
            <input type="file" onChange={handleChange} ref={inputFile} accept=".xlsx, .xls, .csv, .xlsm" className="file_hide" />
            <button className="default-button-red btn-block" onClick={() => inputFile.current.click()} onChange={() => handleChange(InputEvent)} disabled={disabledUpload}>Importar TimeSheet</button>
            <ModalImportarTimeSheet
                isOpen={modalIsOpen}
                idTimesheet={idTimesheet}
                file={file}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                timesheet={timesheet}
                importData={importData}
                totalAtividades={totalAtividades}
                itensAtividades={listaItemAtividades}
                quantidadeHoras={quantidadeHoras}
                valorTotal={valorTotal}
                alertData={alertData}
                alertPerito={alertPerito}
                grupoAtividades={grupoAtividades}>
            </ModalImportarTimeSheet>
        </StyledUploadTimeSheet>
    );
}

export default UploadTimeSheet;